<template>
  <div class="card-nav-locacao">
    <div class="nav-grupo">
      <!-- Cada item do menu de navegação da locação -->
      <router-link
        v-for="(item, indice) in itens"
        :key="item.label"
        :to="`${item.rota}/${pasta}`"
        class="nav-item"
        :class="{ ativo: itemAtivo(item.rota) }"
        :title="item.label"
        :style="{ animationDelay: indice * 70 + 'ms' }"
      >
        <span class="nav-item-icone">
          <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path :d="item.svg" />
          </svg>
        </span>
        <span class="nav-item-label">{{ item.label }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
// Menu de navegação por ícones das telas do sistema de locação.
// Usa SVG inline (Material) na cor da marca + destaque do item ativo.
export default {
  name: "CardNavLocacao",
  props: {
    pasta: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      itens: [
        { label: "FICHA", rota: "/locacao", svg: "M14,2H6C4.9,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V8L14,2M18,20H6V4H13V9H18V20Z" },
        { label: "BOLETOS", rota: "/boletos", svg: "M18,17H6V15H18M18,13H6V11H18M18,9H6V7H18M19,3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z" },
        { label: "REPASSES", rota: "/repasses", svg: "M6.99,11L3,15L6.99,19V16H14V14H6.99V11M21,9L17.01,5V8H10V10H17.01V13L21,9Z" },
        { label: "IPTU", rota: "/iptuClientes", svg: "M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" },
        { label: "SEGURO", rota: "/seguroFianca", svg: "M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9L10,17Z" },
        { label: "RELATÓRIOS", rota: "/relatorios", svg: "M5,9.2H3V20.8H5V9.2M7,3H5V20.8H7V3M12.1,7H9.9V20.8H12.1V7M16,10.4H13.9V20.8H16V10.4M20,4.1H17.9V20.8H20V4.1Z" },
      ],
    };
  },
  methods: {
    // Compara o primeiro segmento da rota atual com a rota do item
    itemAtivo(rota) {
      return this.$route.path.split("/")[1] === rota.replace("/", "");
    },
  },
};
</script>

<style scoped>
/* Card base no estilo visual do sistema */
.card-nav-locacao {
  background: #fff;
  border-radius: 14px;
  border: 1px solid #ece8e7;
  box-shadow: 0 4px 16px rgba(76, 28, 23, 0.08);
  padding: 16px 10px;
}
.nav-grupo {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 12px;
  text-decoration: none;
  animation: subidaNav 0.5s ease both;
  transition: background 0.25s ease;
}
.nav-item-icone {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background: #f7f2f1;
  color: #4C1C17;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;
}
.nav-item-icone svg {
  width: 26px;
  height: 26px;
}
.nav-item-label {
  color: #4C1C17;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: color 0.25s ease;
}
.nav-item:hover {
  background: #faf6f5;
}
.nav-item:hover .nav-item-icone {
  background: #4C1C17;
  color: #fff;
  transform: translateY(-4px) scale(1.06);
  box-shadow: 0 8px 18px rgba(76, 28, 23, 0.28);
}
.nav-item.ativo .nav-item-icone {
  background: #4C1C17;
  color: #fff;
  box-shadow: 0 0 0 4px rgba(76, 28, 23, 0.15);
}
.nav-item.ativo .nav-item-label {
  color: #2b0f0c;
}

/* Entrada escalonada dos itens ao carregar a página */
@keyframes subidaNav {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Ajustes para telas pequenas (3x2) */
@media (max-width: 576px) {
  .card-nav-locacao {
    padding: 12px 6px;
  }
  .nav-grupo {
    gap: 2px;
  }
  .nav-item {
    padding: 6px 4px;
  }
  .nav-item-icone {
    width: 46px;
    height: 46px;
  }
  .nav-item-icone svg {
    width: 22px;
    height: 22px;
  }
  .nav-item-label {
    font-size: 9.5px;
  }
}
</style>